
if (!customElements.get("swiper-slider")) {
  class SwiperSlider extends HTMLElement {
    constructor() {
      super();

      this.slides = this.querySelectorAll(".swiper-slide");
      this.slideContainer = this.querySelector(".swiper");

      this.sliderOptions = this.dataset.options
        ? JSON.parse(this.dataset.options)
        : {};

      if (this.slideContainer && this.slides.length > 0) {          

        document.addEventListener(
           "DOMContentLoaded",
           this.initializeSwiper.bind(this)
         );
                 
        document.addEventListener(
          "shopify:section:load",
          this.initializeSwiper.bind(this)
        );

        this.initializeSwiper.bind(this);          
        if (window.Swiper && !this.initialized) {
          this.initialized = true;
          this.slider = new Swiper(this.slideContainer, this.sliderOptions);
          this.initializeSliderEventListeners();
        } else if (!window.Swiper) {
          console.warn("SwiperSlider - Swiper.js not found");
        }
        
        window.addEventListener("resize", this.handleResize.bind(this));
      }
    }
    initializeSwiper() {
      if (window.Swiper && !this.initialized) {
        this.initialized = true;
        setTimeout(() => {
          this.slider = new Swiper(this.slideContainer, this.sliderOptions);
          this.initializeSliderEventListeners();
        }, 5000)
        this.slider = new Swiper(this.slideContainer, this.sliderOptions);
        this.initializeSliderEventListeners();
      } else if (!window.Swiper) {
        console.warn("SwiperSlider - Swiper.js not found");
      }
    }

    handleResize(e) {
      if (this.slider) {
        setTimeout(() => {
          this.slider.updateSize();
        }, 300);
      }
    }
    initializeSliderEventListeners() {}
  }

  customElements.define("swiper-slider", SwiperSlider);
}


